import { Injectable } from '@angular/core';
import { AppConfiguration } from '../app/conf/app.configuration';
import { Store } from '@ngrx/store';
import { AppState } from '../app/store/AppState';
import { TranslateService } from '@ngx-translate/core';
import { UserPrefs } from '../app/api/UserPrefs-dto';
import { SET_USERPREFS } from '../app/store/userPrefs';
import { PrimeNGConfig } from 'primeng-lts/api';
import { BaseDirectiveObject } from '../app/components/common/base-directive-object';


const DEFAULT_ACTIVE_LANG = ['es', 'ca', 'gl'];

@Injectable()
export class LanguageService extends BaseDirectiveObject {

  private userPref: UserPrefs;

  constructor(private appConfiguration: AppConfiguration, private store: Store<AppState>
    , private translateService: TranslateService
    , private config: PrimeNGConfig) {

    super();
    this.subscribe(store.select('userPrefs'), (prefs: UserPrefs) => {
      if (this.userPref && prefs && this.userPref?.locale !== prefs?.locale) {
        this.changeAppLanguage(prefs.locale);
      }
      this.userPref = prefs;
    });
  }

  public init(): void {
    this.translateService.addLangs(this.getAvaliableLanguages());
    this.translateService.setDefaultLang(this.getAppDefaultLanguage());
    this.changeAppLanguage(this.getAppLanguage());
  }

  public getUserLanguage(): string {
    return this.userPref.locale;
  }

  public setUserLanguage(lang: string): void {
    this.userPref.locale = lang;
    let thisUserPrefs = this.userPref;
    this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));
  }

  public getAvaliableLanguages(): string[] {
    return this.appConfiguration.getValue('activeLanguages') || DEFAULT_ACTIVE_LANG;
  }

  public getAppDefaultLanguage(): string {
    return this.getAvaliableLanguages()[0];
  }

  public getAppLanguage(): string {
    return this.getUserLanguage() || this.getAppDefaultLanguage();
  }

  public changeAppLanguage(lang: string): void {
    this.translateService.use(lang);
    this.subscribe(this.translateService.get('primeng'), res => this.config.setTranslation(res));
  }

}


export const PRIMENG_DATE_FORMAT = 'dd/mm/yy';


export const DATEPIPE_DATE_FORMAT = 'dd/MM/yyyy';
export const DATEPIPE_DATETIME_FORMAT = 'dd/MM/yyyy HH:mm:ss';
